import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loader } from 'graphql.macro';
import { useMutation, useQuery } from 'react-apollo-hooks';

import { WithTitle, useNotifications } from '@loyalup/ui';

import Phone from '../../components/Phone';
import PhoneForm from '../../components/PhoneForm';
import onlyData from '../../utils/onlyData';

import TrigNotification from './TriggerNotification';

import s from './TriggerCampaigns.module.css';

const COMPANY_QUERY = loader('../../gql/queries/Company.gql');
const SET_TRIGGER_CAMPAIGN_MUTATION = loader('../../gql/mutations/SetTriggerCampaign.gql');

const TriggerCampaigns = () => {
  const [t] = useTranslation();

  const [sendNotification] = useNotifications();

  const [active, setActive] = useState('passActivation');

  const { data } = useQuery(COMPANY_QUERY, {
    suspend: false,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const [bday, setBday] = useState(null);

  const [passActivation, setPassActivation] = useState(null);

  const [setTriggerCampaign] = useMutation(SET_TRIGGER_CAMPAIGN_MUTATION);

  useEffect(() => {
    if (data) {
      const { triggerCampaigns } = data.company;
      setBday(state => ({ ...state, ...onlyData(triggerCampaigns.bday) }));
      setPassActivation(state => ({ ...state, ...onlyData(triggerCampaigns.passActivation) }));
    }
  }, [data]);

  const toggleActivation = () => {
    const { enabled } = passActivation;
    setPassActivation({ ...passActivation, enabled: !enabled });
    setTriggerCampaign({
      variables: {
        type: 'PASS_ACTIVATION',
        enabled: !enabled,
        text: data.company.triggerCampaigns.passActivation.text,
      },
    });
  };

  const toggleBirthday = () => {
    const { enabled } = bday;
    setBday({ ...bday, enabled: !enabled });
    setTriggerCampaign({
      variables: {
        type: 'BDAY',
        enabled: !enabled,
        text: data.company.triggerCampaigns.bday.text,
      },
    });
  };

  const setActivePushPreview = clickedElement => {
    if (clickedElement !== active) {
      setActive(clickedElement);
    }
  };

  const onSavePassActivationChanges = () => {
    setPassActivation({ ...passActivation, loading: true });
    setTriggerCampaign({
      variables: {
        type: 'PASS_ACTIVATION',
        enabled: passActivation.enabled,
        text: passActivation.text,
      },
      update: () => {
        setPassActivation({ ...passActivation, loading: false });
        sendNotification({ text: t('Сохранено') });
      },
    });
  };

  const onSaveBdayChanges = () => {
    setBday({ ...bday, loading: true });
    setTriggerCampaign({
      variables: {
        type: 'BDAY',
        enabled: bday.enabled,
        text: bday.text,
      },
      update: () => {
        setBday({ ...bday, loading: false });
        sendNotification({ text: t('Сохранено') });
      },
    });
  };

  const getPreviewTextByType = active => {
    switch (active) {
      case 'bday':
        return bday.text;
      case 'passActivation':
        return passActivation.text;
      default:
        return '';
    }
  };

  if (!bday || !passActivation) {
    return null;
  }

  return (
    <WithTitle title={t('Рассылки')}>
      <div className={s.header}>
        <h1>{t('Триггерные Push-уведомления')}</h1>
      </div>
      <main className={s.main}>
        <PhoneForm
          renderPhone={() => (
            <Phone
              notificationTitle={data?.company.name}
              notificationType={'PUSH'}
              iconSrc={data?.company.currentPassDesign?.iconImage.url || data?.company.defaultPassDesign?.iconImage.url}
              notificationText={getPreviewTextByType(active)}
              hint={t(
                'Триггерные уведомления срабатывают автоматически в зависимости от заданных условий, снимая с вас часть рутинных действий.',
              )}
            />
          )}
        >
          {() => (
            <div className={s.notificationsContainer}>
              <TrigNotification
                {...passActivation}
                onActivate={() => setActivePushPreview('passActivation')}
                onChangeText={text => setPassActivation({ ...passActivation, text })}
                setToggle={toggleActivation}
                onSave={onSavePassActivationChanges}
              />
              <TrigNotification
                {...bday}
                onActivate={() => setActivePushPreview('bday')}
                onChangeText={text => setBday({ ...bday, text })}
                setToggle={toggleBirthday}
                onSave={onSaveBdayChanges}
              />
            </div>
          )}
        </PhoneForm>
      </main>
    </WithTitle>
  );
};

export default TriggerCampaigns;
